export const URLBACKGROUND = "https://source.unsplash.com/random?wallpapers";
export const TOKENSTORAGE = "TokenStorage";
